import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import format from 'date-fns/format';
import { Currency, ChangeIndicatedPercent } from '../../../../../../src/components/common/number';
import { Info2 } from '@dbk/ui-icons';
import Text,{H1} from '@dbk/ui-text';
import { NO_DATA, } from '../../../constants';
import styles from './market-value-header.styles';
import Popover from '@dbk/ui-popover';
import { PALETTE } from '../../../../../../src/constants';

function MarketValueHeader({
  marketValue,
  marketValueAsOfDate, 
  marketValueUnit,
  dayChange,
  dayChangeUnit,
  dayChangePercentage,
  dayChangeVisible,
  marketLabelText,
  twrr,
  messages,
  location,
  isPopoverRequired
}) {
  const asOfDate = marketValueAsOfDate? format(new Date(marketValueAsOfDate) , 'dd.MM.yyyy'): '';

  return (
  

      <div  className="marketContainer" testID="market-value-container">
        <div className= "marketValueColumn" >
        <View style={styles.marketValueParent} id="market-value-label" accessible={true}>
            <Text secondary size="large">{messages['app.portfolio.assetHeader.total.title']}{asOfDate}
            </Text>
            {isPopoverRequired && <Popover
                mode="popup"
                orientation="right"
                showOnHover
                popOverClassName="dashboard-summary-popover"
                arrowColor={PALETTE.secondaryActive}
                content={
                  <div>
                    <p>{messages["app.dashboard.summaryData.popoverTxt1"]}</p>
                    <p>{messages["app.dashboard.summaryData.popoverTxt2"]}</p>
                    <p>{messages["app.dashboard.summaryData.popoverTxt3"]}</p>
                  </div>}
              >
                <Info2 className="dashboard-total-mkt-val-Qmark" color={PALETTE.fordGray} height={30} width={30}/>
              </Popover>}
          </View>
        {marketValueUnit ?<H1 className = "summary-header-value-total margin-top-1" tabIndex={0}>
          <Currency
            signBeforeNumber={false}
            // decimalStyle={styles.decimalStyle}
            // currencyStyle = {styles.currencyStyle}
            currency={marketValueUnit}
            renderProps={{
              style: styles.marketValueText,
              // size: 40,
              testID: 'market-value',
            }}
            value={marketValue}
          />
          </H1>:
          <div tabIndex={0} aria-label={messages['app.common.nullValue']}></div>}
        </div>

      
        {location.endsWith('/portfolios') && dayChangeVisible && 
        <div style={{ width: '35%'}} className="dayChangeContainer" testID="day-change-container" accessible={true}>
          <View style={styles.marketValueParent}  accessible={true}>
            <Text secondary size="large">{messages['app.portfolio.listassets.dayChange']}</Text>
          </View>
        <div className="marketContainer margin-top-21">
        {dayChange !=null ? <div tabIndex={0}>
          <Currency
            signBeforeNumber={false}
            renderProps={{
              style : styles.dayChangeValue,
              // size: 19,
              testID: 'day-change',
            }}
            currency = {dayChangeUnit}
            value={dayChange}
          />
          </div>:
          <div tabIndex={0} aria-label={messages['app.common.nullValue']}></div>}
          {dayChangePercentage != null && <div tabIndex={0}><ChangeIndicatedPercent
            renderProps={{
              style: styles.changeIndicatedPercent,
              size: 'large',
              testID: 'day-change-percentage',
            }}
            value={dayChangePercentage}
            withPlusSign
          /> </div>}
        </div>
      </div>}
      {/* render TWRR value */}
      {location.endsWith('/portfolios') &&
       <div className="twrrValueContainer">
       <View style={styles.marketValueParent} id="day-change-label" tabIndex={0} aria-label={messages['app.assets.twrrYTD']}>
          <Text secondary size="large">{messages['app.portfolio.listassets.TWRR']}</Text>
        </View>
        {twrr?<div className="marketContainer marginTop" tabIndex={0}>
          <ChangeIndicatedPercent
            renderProps={{
              style: styles.twrrIndicatedPercent,
              size: 'large',
              testID: 'day-change-percentage',
            }}
            value={twrr[0].performanceTWRR}
            withPlusSign
          />
        </div>:
        <div tabIndex={0} aria-label={messages['app.common.nullValue']}></div>}
         </div>}
      </div>

      
  );
}

MarketValueHeader.propTypes = {
  marketValue: PropTypes.number,
  marketValueUnit: PropTypes.string,
  dayChange: PropTypes.number,
  dayChangeUnit: PropTypes.string,
  dayChangePercentage: PropTypes.number,
  dayChangeVisible: PropTypes.bool,
  marketLabelText: PropTypes.string,
  twrr:PropTypes.array,
  isPopoverRequired: PropTypes.bool
};

MarketValueHeader.defaultProps = {
  dayChangeVisible: true,
  marketLabelText: 'Market Value',
  isPopoverRequired: true
};

export default pure(MarketValueHeader);
